import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Drawer } from "@mui/material";
// config
import colors from "../../../config/colors";
import { DRAWER } from "../../../config/nav";
// redux
import { useDispatch, useSelector } from "../../../redux/store";
import { setCreatorDetails } from "../../../redux/slices/creator";
// sections
import { CreatorDetails } from "../../../sections/Discover/details";

const CreatorDetailsDrawer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const activeView = useSelector((state) => state.creator.layoutView);
  const creatorDetails = useSelector((state) => state.creator.creatorDetails);
  const isCreatorDrawerOpen = !!creatorDetails;
  const handleCloseDrawer = () => {
    dispatch(setCreatorDetails(null));
  };

  useEffect(() => {
    if (!location.pathname.includes("discover")) {
      dispatch(setCreatorDetails(null));
    }
  }, [dispatch, location.pathname]);

  return (
    <>
      <Drawer
        anchor="right"
        open={isCreatorDrawerOpen}
        onClose={handleCloseDrawer}
        sx={{
          "& .MuiDrawer-paper": {
            width: DRAWER.W_CREATOR_DETAILS,
            backgroundColor: colors.white,
            boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.12)",
          },
        }}
      >
        <CreatorDetails />
      </Drawer>
    </>
  );
};

export default CreatorDetailsDrawer;
